module.exports = __webpack_public_path__ + "img/adblue2.643f65f9.jpg";